import * as st from './liveState.module.scss'
import * as React from 'react'
import { Badge, badges } from 'DVWebNodeUI'

export type LiveStateProps = {
  text?: string
  isLive: boolean
}

export const LiveState = ({ text, isLive }: LiveStateProps) => {
  return (isLive && text ?
    <div className={`${st.liveStatus} avu-full-width`}>
      <Badge use={badges.LIVE}> {text} </Badge>
    </div>
    : null)
}